import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "81",
  height: "72",
  viewBox: "0 0 81 72",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M35.8406 5.79203C37.7519 2.48169 42.5299 2.48168 44.4412 5.79203L77.0515 62.2748C78.9627 65.5851 76.5737 69.7231 72.7512 69.7231H7.53056C3.70811 69.7231 1.31907 65.5851 3.23029 62.2748L35.8406 5.79203Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M37.4353 27.3897H42.4203L42.0323 46.1461H37.8233L37.4353 27.3897ZM41.9159 54.9716C41.3728 55.5018 40.7069 55.7668 39.9181 55.7668C39.1293 55.7668 38.4634 55.5018 37.9203 54.9716C37.3772 54.4285 37.1056 53.7755 37.1056 53.0125C37.1056 52.2496 37.3772 51.603 37.9203 51.0729C38.4634 50.5427 39.1293 50.2776 39.9181 50.2776C40.7069 50.2776 41.3728 50.5427 41.9159 51.0729C42.472 51.603 42.75 52.2496 42.75 53.0125C42.75 53.7755 42.472 54.4285 41.9159 54.9716Z",
      fill: "#FCEBE9"
    }, null, -1)
  ])))
}
export default { render: render }